export default function WebVersionInfo() {
  const buildVersion = process.env.REACT_APP_BUILD_VERSION || "1.0.0";
  const buildDate = process.env.REACT_APP_BUILD_DATE || new Date().toISOString();

  // Parse DD-MM-YYYY manually
  const parsedDate = (() => {
    if (/^\d{2}-\d{2}-\d{4}$/.test(buildDate)) {
      const [day, month, year] = buildDate.split("-");
      return new Date(`${year}-${month}-${day}`);
    }
    return new Date(buildDate); // fallback
  })();

  const formattedDate = parsedDate.toLocaleString("en-US", {
    year: "numeric",
    month: "short",
    day: "2-digit",
  });

  return <>Version : {buildVersion} — {formattedDate}</>;
}
